import { SDUIFlowLayoutRenderer } from "@faire/retailer-visitor-shared/components/SDUI/LayoutRenderers/FlowLayout/SDUIFlowLayoutRenderer";
import { SDUILayoutRendererProps } from "@faire/retailer-visitor-shared/components/SDUI/LayoutRenderers/types";
import React from "react";

export const SDUILayoutRenderer: React.FC<SDUILayoutRendererProps> = ({
  items,
  layout,
  isFilterablePaginatedSection,
  viewport,
  numFirstRows,
  pageParams,
  shouldSetUPLTValues,
}) => {
  if (!layout) {
    return null;
  }

  if (!items || items.length === 0) {
    return null;
  }

  if (layout?.flow_layout) {
    return (
      <SDUIFlowLayoutRenderer
        items={items}
        flowLayout={layout.flow_layout}
        viewport={viewport}
        numFirstRows={numFirstRows}
        shouldBatchRender={isFilterablePaginatedSection}
        pageParams={pageParams}
        shouldSetUPLTValues={shouldSetUPLTValues}
      />
    );
  }

  return null;
};
